import type { FC, SVGAttributes } from 'react';

const IconMatras: FC<SVGAttributes<SVGSVGElement>> = (props) => {
  return (
    <svg
      {...props}
      width='30'
      height='31'
      viewBox='0 0 30 31'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M0.520725 16.5526V22.1213C0.520725 23.3639 1.48114 24.3713 2.66588 24.3713H27.3352C28.5199 24.3713 29.4803 23.3639 29.4803 22.1213V16.5526M4.27422 17.7983V24.5M8.56453 17.7983V24.5M12.8548 17.7983V24.5M17.1452 17.7983V24.5M21.4355 17.7983V24.5M25.7258 17.7983V24.5M2.66536 10.4179L4.20719 9.68763C5.18741 9.22333 6.31062 9.22333 7.29085 9.68763C8.27108 10.1519 9.39428 10.1519 10.3745 9.68763C11.3547 9.22333 12.4779 9.22333 13.4582 9.68763C14.4384 10.1519 15.5616 10.1519 16.5418 9.68763C17.5221 9.22333 18.6453 9.22333 19.6255 9.68763C20.6057 10.1519 21.7289 10.1519 22.7092 9.68763C23.6894 9.22333 24.8126 9.22333 25.7928 9.68763L27.3346 10.4179M29.0273 14.5603L27.6698 13.7387C26.5497 13.0608 25.17 13.0608 24.0499 13.7387C22.9298 14.4167 21.55 14.4167 20.4299 13.7387C19.3098 13.0608 17.9301 13.0608 16.81 13.7387C15.6899 14.4167 14.3101 14.4167 13.19 13.7387C12.0699 13.0608 10.6902 13.0608 9.57007 13.7387C8.44998 14.4167 7.07022 14.4167 5.95013 13.7387C4.83003 13.0608 3.45027 13.0608 2.33018 13.7387L0.972695 14.5603M2.64734 18.1851H27.3527C28.8786 18.1851 29.9166 16.5611 29.3371 15.0805L26.7975 8.5931C26.3018 7.32682 25.126 6.5 23.8209 6.5H6.17908C4.87401 6.5 3.69819 7.32682 3.20249 8.5931L0.662947 15.0805C0.0833512 16.5611 1.12138 18.1851 2.64734 18.1851Z'
        stroke='#404040'
      />
    </svg>
  );
};

export default IconMatras;
